/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';
import { Link as RouterLink } from 'react-router-dom';
import Barcode from 'react-barcode';

export const Container = styled(Modal.Body)`
  background-color: white;
  border-radius: 10px;
  width: auto;
  height: auto;
  padding: 25px;
  overflow-x: hidden;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.mediumPurple};
  /* @media (max-width: 375px) { */
  /* font-size: 1.4375rem; */
  /* } */
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.mediumPurple};
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
  /* @media (max-width: 375px) {
    font-size: 1.125rem;
  } */
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: ${({ theme }) => theme.colors.blue};
  cursor: pointer;
  /* @media (max-width: 370px) { */
  /* font-size: 1.125rem; */
  /* } */
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
`;

export const CustomerInfoContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 25px;
  padding-bottom: 14px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoTitle = styled.span`
  font-size: 14px;
  height: 23px;
  color: ${({ theme }) => theme.colors.mediumPurple};
`;

export const InfoText = styled.span`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 13px;
  height: 23px;
  @media (max-width: 460px) {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Hr = styled.hr`
  border-top: 1px dashed ${({ theme }) => theme.colors.lightGray};
  margin: 0px;
`;

export const DetailsContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 17px;
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;
  margin-top: 10px;
`;

export const SectionTitle = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-weight: bold;
  font-size: 19px;
`;

export const Link = styled(RouterLink)`
  text-decoration: none !important;
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 13px;
  height: 23px;
`;

export const InvoiceNumber = styled.span`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 13px;
  height: 23px;
  text-decoration: underline;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StatusIcon = styled.div`
  background-color: ${(props) => props.color};
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin-right: 10px;
`;

export const StatusText = styled.span`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 15px;
`;

export const BankSlipContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 20px;
  margin-bottom: 10px;
`;

export const BankSlipContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 28px;
  margin-top: 3px;
`;

export const TypeableLineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .codeNotas {
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (max-width: 992px) {
    .codeNotas {
      max-width: 180px;
    }
  }
`;

export const TypeableLineText = styled.span`
  color: ${({ theme }) => theme.colors.mediumPurple};
  font-size: 1rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
`;

export const TypeableLineIcon = styled.i`
  font-size: 20px;
  font-weight: bold;
  margin-left: 5px;
  color: #000000;
`;

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const BarcodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const BarcodeContent = styled.div`
  margin-left: -9px !important;
  margin-top: -2px;
  /* @media (max-width: 467px) {
    display: none;
  } */
`;

export const BarcodeResponsive = styled.div`
  display: none;
  @media (max-width: 467px) {
    margin-left: -9px !important;
    display: flex;
  }
`;

export const RemoveSpace = styled.div`
  margin-bottom: -15px;
`;

export const DuplicateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 18px;
`;

export const DuplicateButton = styled.div``;

export const DuplicateIcon = styled.i`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.lightBlue};
  font-size: 24px !important;
  margin-left: 12px;
`;

export const DuplicateLoading = styled.i`
  color: ${({ theme }) => theme.colors.lightBlue};
  font-size: 24px !important;
  margin-left: 12px;
`;

export const DuplicateText = styled.span`
  font-size: 15px;
  font-weight: bold;
  color: #464646;
`;
